import get from 'lodash/get';

import initializeApp from 'actions/app/initializeApp';
import authenticateWithChatProvider from 'actions/user/authenticateWithChatProvider';
import appEvents from 'events/app';

export default (async function checkAuth(dispatch, getState, { chatGateway, sessionGateway }) {
  const authCredentials = sessionGateway.getSession();
  const state = getState();
  const user = get(getState(), 'user');
  const id = get(user, 'id');
  const hasJwt = !!get(authCredentials, 'jwt', false);

  if (!id) {
    // TODO: [Albert] this probably shouldnt happen here and should occur upstream before checkAuth is called
    return dispatch(initializeApp);
  }

  if (!hasJwt) {
    try {
      const { name, email } = user;
      const { appId, loginDomain, orgDomain } = state.app;

      const response = await chatGateway.auth({ name, email, orgDomain, loginDomain, appId });
      if (response.status < 200 || response.status >= 300) {
        return dispatch(appEvents.serverError({ reason: response.status, err: get(response, 'data.message') }));
      }

      const { userId, jwt, gladlyCustomerId } = response.data;
      sessionGateway.patchSession({ userId, gladlyCustomerId, jwt, created: Date.now() });
    } catch (error) {
      return dispatch(appEvents.serverError({ reason: 500, err: error.message || 'unexpected error occurred' }));
    }
  }

  return await dispatch(authenticateWithChatProvider);
});
